/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAliasesResponse
 */
export interface GetAliasesResponse {
    /**
     * Map with said as keys and related aliases as values
     * @type {{ [key: string]: string; }}
     * @memberof GetAliasesResponse
     */
    saidToAlias?: { [key: string]: string; };
}

/**
 * Check if a given object implements the GetAliasesResponse interface.
 */
export function instanceOfGetAliasesResponse(value: object): boolean {
    return true;
}

export function GetAliasesResponseFromJSON(json: any): GetAliasesResponse {
    return GetAliasesResponseFromJSONTyped(json, false);
}

export function GetAliasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAliasesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'saidToAlias': json['saidToAlias'] == null ? undefined : json['saidToAlias'],
    };
}

export function GetAliasesResponseToJSON(value?: GetAliasesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'saidToAlias': value['saidToAlias'],
    };
}

